import { SearchModelBase } from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class BTLoadPlanListItem extends SearchModelBase {
    id: number = 0;
    loadNo: string = '';
    companyName: string = '';
    loadDate: string | null = null;
    fromLoadDate: string | null = null;
    toLoadDate: string | null = null;
    arrival: string | null = null;
    fromArrival: string | null = null;
    toArrival: string | null = null;
    arrived: boolean = false;
    carrier: string = '';
    departure: string | null = null;
    fromDeparture: string | null = null;
    toDeparture: string | null = null;
    departed: boolean = false;
    isClosed: boolean|null = null;
    broker: string = '';
    completedDate: string | null = null;
    fromCompletedDate: string | null = null;
    toCompletedDate: string | null = null;
    completed: string = '';
    driver: string = '';
    driver2: string = '';
    orderNo: string = '';
    loadSize: string = '';
    origin: string = '';
    dest: string = '';
    truckNo: string = '';
    vanNo: string = '';
    status: string = '';
    u1ID: string = '';
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    u2ID: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    
    draft: boolean = false;
    invStat: string = '';
    billStat: string = '';
    loadStatus: string = '';
    branch: string = '';
    recognized: string = '';
    orderId: number  = 0 ;
    orderCnt: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'R', width: 30, dataIndex: 'recognized', noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        XCol.Create({ col: 2, text: 'INV', width: 40, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 3, text: 'BIL', width: 40, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 4, text: 'Draft', width: 40, dataIndex: 'draft', type: XCol.XCellType.Bool, noNullOrEmptySearch: true}),
        XCol.Create({ col: 5, text: 'Load Status', width: 80, dataIndex: 'loadStatus', noNullOrEmptySearch: true}),
        XCol.Create({ col: 6, text: 'Load #', width: 100, dataIndex: 'loadNo', defaultColumnFocus : true}),
        XCol.Create({ col: 7, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'Load Date', width: 75, dataIndex: 'loadDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 9, text: 'Arrival', width: 75, dataIndex: 'arrival', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Arrived', width: 60, dataIndex: 'arrived', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 11, text: 'Carrier', width: 120, dataIndex: 'carrier'}),
        XCol.Create({ col: 12, text: 'Departure', width: 75, dataIndex: 'departure', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 13, text: 'Departed', width: 60, dataIndex: 'departed', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 14, text: 'Broker', width: 120, dataIndex: 'broker'}),
        // XCol.Create({ col: 15, text: 'Complete Date', width: 90, dataIndex: 'completedDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        // XCol.Create({ col: 16, text: 'Completed', width: 70, dataIndex: 'completed', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 15, text: 'Driver', width: 100, dataIndex: 'driver'}),
        XCol.Create({ col: 16, text: 'Driver2', width: 100, dataIndex: 'driver2'}),
        XCol.Create({ col: 17, text: 'PRO #', width: 120, dataIndex: 'orderNo'}),
        XCol.Create({ col: 18, text: 'Load Size', width: 110, dataIndex: 'loadSize'}),
        XCol.Create({ col: 19, text: 'Origin', width: 150, dataIndex: 'origin'}),
        XCol.Create({ col: 20, text: 'Dest', width: 120, dataIndex: 'dest'}),
        XCol.Create({ col: 21, text: 'Truck #', width: 100, dataIndex: 'truckNo'}),
        XCol.Create({ col: 22, text: 'VAN #', width: 100, dataIndex: 'vanNo'}),
        XCol.Create({ col: 23, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 24, text: 'Create By', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 25, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 26, text: 'Update By', width: 80, dataIndex: 'u2ID'}),
    ];

    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };

    public static OrderBy = { orderBy: BTLoadPlanListItem.prototype.id, orderByAscending: false };

    public static formatData(data: BTLoadPlanListItem[]) {
        return data.map((d: BTLoadPlanListItem) => ({
            ...d,
        }));
    }

    public static MapSearchFields: { [key: string]: { [key: string]: string } } = {
        loadDate: { from: 'fromLoadDate', to: 'toLoadDate' },
        arrival: { from: 'fromArrival', to: 'toArrival' },
        departure: { from: 'fromDeparture', to: 'toDeparture' },
        // completedDate: { from: 'fromCompletedDate', to: 'toCompletedDate' },
        u1Date: { from: 'fromU1Date', to: 'toU1Date' },
        u2Date: { from: 'fromU2Date', to: 'toU2Date' },
    }
}